<script>
import { healthVaultService } from '@/src/services/safehaven/HealthVaultService'
import { formatDateMoment } from '@utils/format-date'
import FilePreviewImage from '@components/file-preview-image.vue'
import FilePreviewPdf from '@components/file-preview-pdf.vue'

export default {
  components: { FilePreviewImage, FilePreviewPdf },
  data() {
    return {
      revokeDialog: false,
      selected: '',

      headers: [
        {
          text: 'Sender',
          align: 'start',
          value: 'sender_name',
          sortable: false,
        },
        { text: 'Document Name', value: 'document_name', sortable: false },
        { text: 'Access Expires', value: 'expiry_date', sortable: false },
        { text: '', value: 'action', sortable: false },
      ],
      receivedDoc: [],
      options: {},
      timeout: null,
      totalRecord: 0,
      totalPages: 0,
      filterDetails: {
        page_count: 1,
      },
      acceptedTypes: ['jpg', 'jpeg', 'png'],
      pdfDialog: false,
      imageDialog: false,
      toPreview: null,
      extension: null,
    }
  },
  async mounted() {
    this.getAllReceivedRecords()
  },
  methods: {
    formatDateMoment,
    revokePopup(item) {
      this.selected = item
      this.revokeDialog = true
    },
    getAllReceivedRecords() {
      this.loading = true
      healthVaultService.getReceivedDocument(this.filterDetails).then((res) => {
        if (!this.receivedDoc.length) {
          this.totalRecord = res.data.number_of_records
          this.totalPages = Math.ceil(this.totalRecord / 10)
          this.receivedDoc = res.data.records
        } else {
          this.receivedDoc = this.receivedDoc.concat(res.data.records)
        }
      })
    },
    onScroll(e) {
      if (this.filterDetails.page_count < this.totalPages) {
        this.timeout && clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          this.filterDetails.page_count = this.filterDetails.page_count + 1
          const { scrollTop } = e.target
          this.getAllReceivedRecords()

          this.$nextTick(() => {
            e.target.scrollTop = scrollTop
          })
        }, 500)
      }
    },
    preview(item) {
      if (item.is_access_revoked) {
        this.$router.push({ name: 'share-record-link-revoked' })
      } else {
        const ext = item.document_name.split('.').pop()
        this.toPreview = item
        healthVaultService.getDocumentFiles(item.document_id).then((res) => {
          this.extension = res.data.file_name.split('.').pop()
          this.toPreview.url = res.data.file_url
          if (ext === 'pdf') {
            this.pdfDialog = true
          } else {
            if (this.acceptedTypes.includes(ext)) {
              this.imageDialog = true
            }
          }
        })
      }
    },
    closeImageDialog() {
      this.toPreview = null
      this.extension = null
      this.imageDialog = false
    },
    closePDFDialog() {
      this.toPreview = null
      this.extension = null
      this.pdfDialog = false
    },
  },
}
</script>

<template>
  <v-row
    no-gutters
    class="my-auto"
    :class="[$vuetify.breakpoint.mobile ? 'pr-1' : 'pr-10']"
  >
    <v-dialog
      :value="imageDialog"
      :fullscreen="true"
      dark
      persistent
      no-click-animation
      transition="fade-transition"
    >
      <FilePreviewImage
        v-if="imageDialog && toPreview && extension"
        :attachment-id="toPreview.document_id"
        :title="toPreview.document_name"
        :type="extension"
        :src="toPreview.url"
        :attachments="[]"
        resource="vault"
        @closeOverlay="closeImageDialog"
      />
    </v-dialog>
    <v-dialog
      :value="pdfDialog && toPreview && extension"
      :fullscreen="true"
      dark
      persistent
      no-click-animation
      transition="fade-transition"
    >
      <FilePreviewPdf
        v-if="pdfDialog"
        :attachment-id="toPreview.document_id"
        :attachments="[]"
        :src="toPreview.url"
        resource="vault"
        @closeOverlay="closePDFDialog"
      />
    </v-dialog>

    <v-col cols="12" md="12" sm="12" lg="12" xl="12">
      <v-data-table
        id="virtual-scroll-recived-doc-table"
        v-scroll:#virtual-scroll-recived-doc-table="onScroll"
        :class="[
          $style.RecievedDocTable,
          [$vuetify.breakpoint.mobile ? 'pt-4' : ''],
        ]"
        class="mt-4"
        :headers="headers"
        :items="receivedDoc"
        :hide-default-footer="true"
        disable-pagination
      >
        <template v-slot:[`item.document_name`]="{ item }">
          <div
            :class="[
              item.is_access_revoked || item.is_deleted
                ? $style.strikeThrough
                : '',
            ]"
            @click="!item.is_deleted ? preview(item) : null"
          >
            {{ item.document_name }}
          </div>
        </template>
        <template v-slot:[`item.sender_name`]="{ item }">
          <div
            :class="[
              item.is_access_revoked || item.is_deleted
                ? $style.strikeThrough
                : '',
            ]"
          >
            {{ item.sender_name }}
          </div>
        </template>
        <template v-slot:[`item.expiry_date`]="{ item }">
          <div
            :class="[
              item.is_access_revoked || item.is_deleted
                ? $style.strikeThrough
                : '',
            ]"
          >
            {{ formatDateMoment(item.expiry_date, 'MM/DD/YYYY') }}
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            v-if="item.is_access_revoked"
            class="text-capitalize"
            text
            color="error"
          >
            Revoked
          </v-btn>
          <v-btn
            v-else-if="item.is_deleted"
            class="text-capitalize"
            text
            color="error"
          >
            Deleted
          </v-btn>
          <v-btn
            v-else-if="item.is_expired"
            class="text-capitalize"
            text
            color="error"
          >
            Expired
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';
.RecievedDocTable {
  padding: 0 15px 10px;
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}
.sharedDocTableHead tr th {
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  color: #aaa !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}

.sharedDocTableBody tr td {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  color: #454648 !important;
  letter-spacing: 0.15px;
}
.sharedDocTableFont {
  font-weight: 600;
  color: #454648 !important;
  text-decoration: none;
}
tbody {
  tr:hover {
    background-color: #f2f9ff !important;
  }
}
.RecievedDocTable tbody {
  tr {
    td:first-child {
      font-weight: 600;
    }
  }
}

.strikeThrough {
  text-decoration: line-through;
  text-decoration-color: #6e6d6d;
}
</style>

<style scoped>
/deep/ .v-data-table__wrapper thead.v-data-table-header tr th.sortable span {
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  color: #aaa !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
/deep/ .theme--light.v-data-table {
  min-height: 100px !important;
  max-height: 400px !important;
  overflow: auto !important;
}
</style>
